import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Legacy from "./pages/Legacy";
import Opportunity from "./pages/Opportunity";
import Sanctuary from "./pages/Sanctuary";
import Strategy from "./pages/Strategy";
import Contact from "./pages/Contact";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Navigation />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/legacy" element={<Legacy />} />
            <Route path="/opportunity" element={<Opportunity />} />
            <Route path="/sanctuary" element={<Sanctuary />} />
            <Route path="/strategy" element={<Strategy />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
